import { useTranslation } from '@gem/modules/i18n';
import {
  useSyncValidation,
  spaceCollectionAvatarValidation,
  spaceCollectionNameValidation,
  ValidationErrorType,
} from '@gem/modules/validations';

import type { IFormFieldValidation, ValidationResult } from '../hooks';

export interface ICreateSpaceCollectionValidations {
  avatar: IFormFieldValidation;
  name: IFormFieldValidation;
}

export const useSharedSpaceCollectionValidations = (): ICreateSpaceCollectionValidations => {
  const { t } = useTranslation();

  const avatarErrorToText = {
    [ValidationErrorType.Empty]: ' ',
  };

  const nameErrorToText = {
    [ValidationErrorType.Empty]: ' ',
    [ValidationErrorType.TooShort]: t('username_min_length_error'),
  };

  const avatarValidator = useSyncValidation();
  const nameValidator = useSyncValidation();

  return {
    avatar: {
      validate: (value, _formData, meta): ValidationResult => {
        return avatarValidator({
          value,
          meta: meta!,
          validate: spaceCollectionAvatarValidation,
          errorToText: avatarErrorToText,
        });
      },
    },
    name: {
      validate: (value, _formData, meta): ValidationResult => {
        return nameValidator({
          value,
          meta: meta!,
          validate: spaceCollectionNameValidation,
          errorToText: nameErrorToText,
        });
      },
    },
  };
};
